<div class="image-visualizer" (wheel)="onWheel($event)">
  <div class="toolbar" *ngIf="showZoomControls">
    <button type="button" class="zoom-btn" (click)="zoomOut()" aria-label="Zoom out">-</button>
    <div class="zoom-value">{{ currentZoom | number: '1.0-2' }}x</div>
    <button type="button" class="zoom-btn" (click)="zoomIn()" aria-label="Zoom in">+</button>
    <button type="button" class="zoom-btn" (click)="resetZoom()"><mat-icon>restart_alt</mat-icon></button>
  </div>

  <div
    #viewport
    class="viewport"
    [class.can-drag]="currentZoom > 1"
    [class.is-dragging]="isDragging"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)"
    (touchcancel)="onTouchEnd($event)"
    (mousedown)="onMouseDown($event)"
    (click)="onViewportClick($event)"
  >
    <div class="stage" [style.width.px]="stageWidth" [style.height.px]="stageHeight">
      <img
        #image
        [src]="imageSrc"
        [alt]="imageAlt"
        draggable="false"
        (load)="onImageLoad()"
      />
      <div class="box-layer">
        <div
          *ngFor="let box of renderedBoxes; trackBy: trackByBox"
          class="box"
          [class.is-focused]="isFocused(box)"
          [class.is-highlighted]="isHighlighted(box)"
          [ngStyle]="getBoxStyle(box)"
          [attr.data-box-id]="box.id"
          [matTooltip]="getTooltip(box)"
          [matTooltipDisabled]="!showBoxTooltip || !getTooltip(box)"
          (mouseenter)="onBoxHover(box)"
          (mouseleave)="onBoxHover(null)"
          (click)="onBoxClick(box)"
          role="button"
          tabindex="0"
          (keydown.enter)="onBoxClick(box)"
          (keydown.space)="onBoxClick(box)"
          aria-label="Bounding box"
        >
          <span class="box-label" *ngIf="showLabels">{{ box.label }}</span>
        </div>
      </div>

      <ng-container *ngIf="showInfoCard && focusedBox as box">
        <div
          class="info-card"
          #infoCard
          [ngStyle]="getInfoStyle(box)"
          (click)="$event.stopPropagation()"
          [class.is-hidden]="isDockedInfo || forceDockedInfo"
        >
          <ng-container
            [ngTemplateOutlet]="infoContent"
            [ngTemplateOutletContext]="{ $implicit: box }"
          ></ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="showInfoCard && focusedBox as box">
    <div class="info-docked" [class.is-active]="isDockedInfo || forceDockedInfo">
      <div class="info-card is-docked">
        <ng-container
          [ngTemplateOutlet]="infoContent"
          [ngTemplateOutletContext]="{ $implicit: box }"
        ></ng-container>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #infoContent let-box>
  <div class="info-title">{{ box.label || box.id }}</div>
  <div class="info-body">
    <div *ngIf="getMetadataEntries(box) as entries">
      <div class="info-row" *ngFor="let entry of entries; trackBy: trackByMetadata">
        <span>{{ entry.key }}</span>
        <span>{{ entry.value }}</span>
      </div>
      <div class="info-empty" *ngIf="entries.length === 0">
        Sin datos
      </div>
    </div>
  </div>
</ng-template>
